import React from 'react'
import PropTypes from 'prop-types'

import Button from 'react-bootstrap/Button'

export default function JumpDown(props) {
  const scrollToContent = (e) => {
    e.preventDefault()

    document.getElementById(props.target_id).scrollIntoView({behavior: "smooth", block: "start"})
  }

  return (
    <Button
      variant="primary"
      size={props.size}
      className={props.className}
      onClick={scrollToContent}
    >
      {props.children}
    </Button>
  )
}

JumpDown.propTypes = {
  children: PropTypes.node.isRequired,
  target_id: PropTypes.string.isRequired,
  size: PropTypes.string,
  className: PropTypes.string,
}